import _styled from '@emotion/styled/base';
import { Colors } from '../../primitives/color.js';
import { border } from '@hubble/tokens/web';

const StyledInput = _styled("input", {
  target: "e16buw0"
})("border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;font-variant-ligatures:none;+.selected{display:none;}:checked{~.unselected{display:none;}+.selected{display:inline-flex;}}:focus-visible~*{box-shadow:inset 0 0 0 2px ", Colors.blue[300], ",0 0 0 1px ", Colors.blue[300], ";border-radius:", border.radius.sm, ";}", ({
  inputSize
}) => inputSize === 'sm' && `
    ~ * {
      height: 10px;
      width: 10px;
    }
  `, ";");

export { StyledInput };
